<template>
    <div>
      <!-- <span v-show="errorMessage" :for="name">{{errorMessage}}</span> -->
      <input 
        @keypress="numbersOnly"
        @keyup.enter="$emit('enter')"
        @input="$emit('input', $event.target.value)"
        type="number"
        class="form-control" 
        onclick="this.select()"
        :value="value"
        :disabled="disabled"
        :name="name" 
        :min="min" 
        :class="{'error': error, 'success': success, 'disabled': disabled}" 
        :placeholder="placeholder">
    </div>
</template>

<script>
export default {
  props: {
    placeholder: String,
    type: String,
    value: {
      type: [String, Number],
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    error: {
      type: Boolean,
      required: false
    },
    success: {
      type: Boolean,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    min: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      errorMessage: ''
    }
  },
  created () {
    document.addEventListener('wheel', function (event) {
      if (document.activeElement.type === 'number') {
        document.activeElement.blur()
      }
    })
  },
  methods: {
    // Input: Number input
    // Only allow numbers [0-9] to be typed in, prevent everything else
    numbersOnly (e) {
      if ((e.keyCode >= 48 && e.keyCode <= 57 || e.keyCode === 46)) {
        // this.errorMessage = ''
      } else {
        e.preventDefault()
        // this.errorMessage = 'Invalid key input, only numbers, periods and commas are allowed.'
      }
    }
  }
}
</script>

<style scoped>
.error {
  border-color: red !important;
}
.success {
  border-color: #58d858 !important;
}
.disabled {
  border-color: rgb(155, 155, 155);
  background-color: rgb(214, 214, 214);
}
</style>
